/*
 * Quotation drawer — one delegated listener for all .quote-trigger buttons.
 * Native <dialog> gives focus-trap, ESC and backdrop for free.
 * Progressive enhancement: if <dialog> is unsupported, triggers do nothing
 * harmful and any real links still work.
 */
(function () {
  'use strict';

  var dlg = document.getElementById('quote-dialog');
  if (!dlg || typeof dlg.showModal !== 'function') {
    return;
  }

  var serviceField = dlg.querySelector('[data-quote-service]');
  var serviceLabel = dlg.querySelector('[data-quote-servicelabel]');
  var urlField     = dlg.querySelector('[data-quote-url]');
  var planWrap     = dlg.querySelector('[data-quote-planwrap]');
  var planField    = dlg.querySelector('[data-quote-plan]');
  var qtyField     = dlg.querySelector('#q-qty');
  var freqField    = dlg.querySelector('#q-freq');
  var lastTrigger  = null;

  // Carry the plan card's product, frequency and quantity into the form, so the
  // enquiry says e.g. "Automatic Sanitary Bin" rather than only the service.
  function fillFromPlan(trigger) {
    var plan = trigger.getAttribute('data-plan') || '';
    if (planField) {
      planField.value = plan;
      planField.disabled = !plan; // disabled fields are not submitted
    }
    if (planWrap) { planWrap.hidden = !plan; }

    var card = trigger.closest('.plan-tile__cfg');
    if (!card) { return; }
    var qty = card.querySelector('select[name="quantity"]');
    if (qty && qty.value && qtyField) { qtyField.value = qty.value; }
    var freq = card.querySelector('.plan-freq__btn.is-active');
    if (freq && freqField) {
      var label = freq.textContent.trim().toLowerCase();
      Array.prototype.forEach.call(freqField.options, function (o) {
        if (o.text.trim().toLowerCase() === label) { freqField.value = o.value || o.text; }
      });
    }
  }

  function push(event, service) {
    if (window.dataLayer) {
      window.dataLayer.push({ event: event, service_name: service || '' });
    }
  }

  // Open — delegated so it also covers buttons rendered later.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.quote-trigger');
    if (!trigger) {
      return;
    }
    e.preventDefault();
    lastTrigger = trigger;

    var service = trigger.getAttribute('data-service') || '';
    if (serviceField) { serviceField.value = service; }
    if (serviceLabel && service) { serviceLabel.textContent = 'Quote for: ' + service; }
    if (urlField) { urlField.value = window.location.href; }
    fillFromPlan(trigger);

    dlg.showModal();

    var first = dlg.querySelector('input:not([type=hidden]):not([readonly]), select, textarea');
    if (first) { first.focus(); }

    push('quote_form_open', service);
  });

  // Return focus to the trigger after closing.
  dlg.addEventListener('close', function () {
    if (lastTrigger) { lastTrigger.focus(); }
  });

  // Click on the backdrop (outside the inner panel) closes the drawer.
  dlg.addEventListener('click', function (e) {
    if (e.target === dlg) { dlg.close(); }
  });

  // Analytics on submit.
  var form = dlg.querySelector('.quote-form');
  if (form) {
    form.addEventListener('submit', function () {
      push('quote_form_submit', serviceField ? serviceField.value : '');
    });
  }

  // Shopify reloads with ?contact_posted=true after a successful send — reopen
  // the drawer so the success message is visible.
  if (/[?&]contact_posted=true/.test(window.location.search)) {
    dlg.showModal();
  }
})();
